import styled from "../../../core/styled-components.mjs";
import { cssSpacing } from "../../../core/styles/index.mjs";
var applyBorderRadius = function applyBorderRadius(_ref) {
  var radiusLeft = _ref.radiusLeft,
    radiusRight = _ref.radiusRight;
  if (radiusLeft && radiusRight) {
    return cssSpacing('tighter-4', '4px');
  }
  if (radiusLeft) {
    return "".concat(cssSpacing('tighter-4', '4px'), " 0 0 ").concat(cssSpacing('tighter-4', '4px'));
  }
  if (radiusRight) {
    return "0 ".concat(cssSpacing('tighter-4', '4px'), " ").concat(cssSpacing('tighter-4', '4px'), " 0");
  }
  return 'unset';
};
export var Wrapper = styled.div.withConfig({
  displayName: "indexstyled__Wrapper",
  componentId: "sc-lbkjz6-0"
})(["display:flex;"]);
export var WrapperDropdown = styled.div.withConfig({
  displayName: "indexstyled__WrapperDropdown",
  componentId: "sc-lbkjz6-1"
})(["margin-right:", ";margin-left:", ";button{border-radius:", ";}"], function (props) {
  return props.radiusLeft ? '-1px' : 'unset';
}, function (props) {
  return props.radiusRight ? '-1px' : 'unset';
}, applyBorderRadius);
export var WrapperInput = styled.div.withConfig({
  displayName: "indexstyled__WrapperInput",
  componentId: "sc-lbkjz6-2"
})(["flex:1;input{border-radius:", ";}"], applyBorderRadius);
export var WrapperButton = styled.div.withConfig({
  displayName: "indexstyled__WrapperButton",
  componentId: "sc-lbkjz6-3"
})(["margin-left:", ";"], cssSpacing('tighter', '12px'));